<ng-container *ngIf="loaded">
  <div class="svg-container" #container [innerHTML]="localSvg | safeHtml" (click)="clickHandler($event)" [hidden]="svgNotLoaded"></div>

  <div class="d-block spinner-border mx-auto" role="status" *ngIf="svgNotLoaded">
    <span class="visually-hidden"></span>
  </div>
</ng-container>
